<template>
  <div class="main-box">
    <div class="m-message" v-scroll-bottom="session.messages">
      <ul>
        <li v-for="(item, index) in session.messages" :key="index">
          <p class="time" :class="{ selftime: item.self }">
            <span>{{ item.date | time }}</span>
          </p>
          <div class="main" :class="{ self: item.self }">
            <img class="avatars" width="30" height="30" :src="item | avatar" />
            <div :class="{ text: true, otext: item.imgurl || item.type == 2 }">
              <!-- 文本消息 -->
              <template v-if="item.type == 0">
                <div v-html="item.text"></div>
              </template>
              <!-- 图片消息 -->
              <template v-if="item.type == 1">
                <viewer
                  :images="
                    session.messages
                      .filter((t) => t.imgurl)
                      .map((x) => x.imgurl)
                  "
                  style="maxwidth: 300px; maxheight: 200px"
                >
                  <img
                    v-show="ig == item.imgurl"
                    :src="ig"
                    v-for="(ig, g) in session.messages
                      .filter((t) => t.imgurl)
                      .map((x) => x.imgurl)"
                    :key="g"
                  />
                </viewer>
              </template>
              <!-- 文件类型 -->
              <template v-if="item.type == 2">
                <chat-upload
                  ref="uploadFile"
                  :content="item.text"
                  :url="item.fileUrl"
                  :isShow="false"
                ></chat-upload>
              </template>
              <!-- 语音 -->
              <template v-if="item.type == 3">
                <div style="display: flex; align-items: center">
                  <div
                    :style="{
                      width:
                        Math.ceil(JSON.parse(item.text).seconds) * 30 + 'px',
                      height: '35px',
                      display: 'flex',
                      'flex-direction': item.self ? 'row-reverse' : 'inherit',
                      'justify-content': 'space-between',
                      'align-items': 'center'
                    }"
                    @click="playAudio(item, index)"
                  >
                    <img
                      v-if="isPlay && clickActive == index"
                      :style="{transform: item.self ? 'scale(0.5) rotateY(180deg)' : 'scale(0.5)'}"
                      :src="require('@/assets/images/sound1.gif')"
                      alt=""
                    />
                    <img
                      v-else
                      :style="{transform: item.self ? 'scale(0.5) rotateY(180deg)' : 'scale(0.5)'}"
                      :src="require('@/assets/images/audio.png')"
                      alt=""
                    />
                    <span>{{Math.ceil(JSON.parse(item.text).seconds) + "'"}}</span>
                  </div>
                </div>
                <audio
                  :id="'audio'+item.id"
                  controls
                  controlsList="nodownload"
                  :hidden="true"
                >
                  <source :src="JSON.parse(item.text).audioUrl" />
                </audio>
              </template>
            </div>
            <span v-if="item.self"
              style="
                font-size: 12px;
                display: flex;
                align-items: flex-end;
                color: #ccc;
              "
            >
              <span>{{ item.alreadyread == 0 ? "未读" : "已读" }}</span>
            </span>
            <!-- 好友的语音秒数 -->
            <span v-if="!item.self && item.type == 3" 
            style="font-size: 14px;margin-left: 10px;color: rgb(204, 204, 204);display: flex;align-items: center;flex-direction: column;justify-content: space-around;">
              <i
                v-if="item.alreadyread == 0"
                style="
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background-color: red;
                "
              ></i>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { decodeText } from "@/mqtt/decodeText.js";
import chatUpload from "./upload";
import vue from "vue";
let vm = {};
export default {
  props: ["session", "user", "userList"],
  components: { chatUpload },
  computed: {
    sessionUser() {
      let users = this.userList.filter(
        (item) => item.id === this.session.userId
      );
      return users[0];
    },
  },
  data() {
    vm = this;
    return {
      clickActive:null,
      imgArr: [],
      isPlay: false,
    };
  },
  filters: {
    // 筛选出用户头像
    avatar(item) {
      // 如果是自己发的消息显示登录用户的头像
      let user = item.self ? vm.user : vm.sessionUser;
      return user && user.img;
    },
    // 将日期过滤为 hour:minutes
    time(date) {
      return new Date(new Date(date).getTime()).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  directives: {
    // 发送消息后滚动到底部
    "scroll-bottom"(el) {
      vue.nextTick(() => {
        if(vm.clickActive || vm.clickActive == 0){
          return
        }
        el.scrollTop = el.scrollHeight - el.clientHeight;
      });
    },
  },
  watch: {
    "session.messages"(val) {
      this.imgArr = [];
      if (val) {
        val.forEach((x) => {
          if (x.imgurl) {
            this.imgArr.push(x.imgurl);
          }
        });
      }
      setTimeout(() => {
        if(this.session.messages && this.session.messages.length>0){
          // 添加语音的结束事件
          this.session.messages.forEach(item => {
            if(item.type == 3){
              document.getElementById('audio'+item.id).addEventListener('ended',()=>{
                this.isPlay = false
              })
            }
          })
        }
      })
    },
  },
  methods: {
    contentList(item) {
      return decodeText(item);
    },
    // 播放语音
    playAudio(item, index) {
      this.clickActive = index
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        if (item.alreadyread == 0 && !item.self) {
          this.axios({
            url: this.zuul + "/xyj-im/r/imChatHistory/readVoiceMessage",
            method: "get",
            params: {
              fromchatid: sessionStorage.getItem('chatid'),
              tochatid: this.session.conversationid,
              topic: this.$topic.$IMNEWS,
              id:item.id
            },
          })
            .then((res) => {
              this.session.messages[index].alreadyread = 1;
              document.getElementById('audio'+item.id).play();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        } else {
          document.getElementById("audio"+item.id).play();
        }
      } else {
        document.getElementById("audio"+item.id).pause();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  height: calc(100% - 222px);
}
img {
  max-width: 200px;
  max-height: 200px;
}
.m-message {
  padding: 10px 15px;
  overflow-y: scroll;
  box-sizing: border-box;
  height: 100%;
  .main {
    max-width: 60%;
    display: flex;
  }
  ul {
    margin: 0 !important;
    padding: 0 !important;
  }
  li {
    margin-bottom: 15px;
    list-style: none;
  }
  .time {
    margin: 7px 0;
    text-align: left;
    box-sizing: border-box;
    padding-left: 30px;
    & > span {
      display: inline-block;
      padding: 0 18px;
      font-size: 12px;
      color: #dcdcdc;
      border-radius: 2px;
      // background-color: #dcdcdc;
    }
  }
  .selftime {
    text-align: right;
    padding-right: 30px;
  }
  .avatars {
    float: left;
    margin: 0 10px 0 0;
    border-radius: 3px;
  }
  .text {
    display: inline-block;
    position: relative;
    padding: 5px 10px;
    max-width: calc(100% - 65px);
    /*min-height: 30px;*/
    line-height: 1.5;
    font-size: 12px;
    text-align: left;
    word-break: break-all;
    background-color: #efefef;
    border-radius: 4px;
    box-sizing: border-box;
    &:before {
      content: " ";
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #efefef;
    }
    /deep/ {
      .pasteImg {
        width: 20px;
        height: 20px;
        vertical-align: sub;
      }
    }
  }
  .self {
    text-align: right;
    max-width: 60%;
    transform: translateX(67%);
    flex-direction: row-reverse;
    .avatars {
      float: right;
      margin: 0 0 0 10px;
    }
    .text {
      background-color: #b2e281;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #b2e281;
      }
    }
  }
  .self {
    text-align: right;
    .avatars {
      float: right;
      margin: 0 0 0 10px;
      user-select: none;
    }
    .otext {
      background-color: #fafafa;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fafafa;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/deep/ {
  .el-image-viewer__close {
    color: #fff !important;
  }
}
.text-item {
  font-size: 14px;
  white-space: pre-wrap;
}

.emmo-images {
  vertical-align: bottom;
  width: 22px;
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/vueChart/message.vue